import React from "react";
import { withTheme } from "styled-components";

/* 
  Opposite angled svg, where the background color is blue
  and the negative space is the svg
  <svg viewBox="0 0 100 100" preserveAspectRatio="none" {...props}>
    <path d="M-10 0l110 100H0l100 NaNz" />
  </svg> 
*/

const Background = props => {
  return (
    <svg
      style={{
        position: "absolute",
        top: 0,
        width: props.width ? props.width : "100%",
        height: props.height ? props.height : "415px",
        fill: props.color ? props.color : props.theme.color.base.getShade(8)
      }}
      className="background-svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <polygon points="100 0,0 0,0 65,100 90" />
    </svg>
  );
};
export default withTheme(Background);
